export const getMarkersUrl = (viewUUID: string) => `/gateway/api/polaris/rest/${viewUUID}/markers`;

export const getMarkersUrlWithId = (viewUUID: string, markerId: string) =>
	`${getMarkersUrl(viewUUID)}/${markerId}`;
